import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function CampaignsIndex() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const campaigns = data?.campaigns || [];

  return (
    <MainPanel
      title={t('campaigns.title')}
      actions={
        <button type="button" className="custio-btn-primary" style={{ borderRadius: 999 }}>
          {t('campaigns.create')}
        </button>
      }
    >
      {campaigns.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('campaigns.emptyTitle')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('campaigns.emptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {campaigns.map((c) => (
            <div
              key={c.id}
              style={{
                background: '#1f2229',
                borderRadius: 16,
                padding: 20,
                color: '#f3f4f6',
                border: '1px solid rgba(255,255,255,0.08)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
                <strong>{c.name}</strong>
                <span
                  style={{
                    background: c.enabled ? '#166534' : '#44403c',
                    color: c.enabled ? '#bbf7d0' : '#d6d3d1',
                    fontSize: 11,
                    fontWeight: 600,
                    padding: '4px 10px',
                    borderRadius: 999,
                  }}
                >
                  {c.enabled ? t('common.enabled') : t('common.disabled')}
                </span>
              </div>
              <p style={{ color: '#9ca3af', margin: '0 0 8px' }}>{c.messageBody}</p>
              <p style={{ fontSize: 12, color: '#6b7280', margin: 0 }}>
                {t('common.type')}: {c.campaignType || '—'}
              </p>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
